import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';

import DetailsList from '../../../../../../common/details-list';
import commonLocales from '../../../../../../../constants/locales';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationSuccess } from './interfaces';

interface Props {
  operation: OperationSuccess;
}

const SuccessOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { details, amount, acquirerMsisdn, operator } = operation;
  return (
    <DetailsFactory
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={
        <DetailsList
          items={[
            { label: commonLocales.operation.label.amount, value: formatToAmount(amount.value) },
            { label: commonLocales.operation.label.externalTransactionId, value: details.externalTransactionId },
            {
              label: commonLocales.operation.label.receiver,
              value: detailsValueFormatter(acquirerMsisdn)
            },
            { label: commonLocales.operation.label.referenceId, value: details.referenceId },
            { label: commonLocales.operation.label.operatorName, value: detailsValueFormatter(operator) }
          ]}
        />
      }
    />
  );
};

export default SuccessOperation;
